import React from "react"
import EventSlide1 from "images/eventSlide1.png";
import EventSlide2 from "images/eventSlide2.png";
import EventSlide3 from "images/eventSlide3.png";
import EventSlide4 from "images/eventSlide4.png";
import OfferSlide1 from "images/offerSlides1.png";
import OfferSlide2 from "images/offerSlides2.png";
import OfferSlide3 from "images/offerSlides3.png";
import RafSlide1 from "images/rafSlide1.png";
import RafSlide2 from "images/rafSlide2.png";
import RafSlide3 from "images/rafSlide3.png";
import SetGoal from "images/1 Set Goal.png";
import SuccessAnalysis from "images/2 Success Analysis.png";
import SuccessReports from "images/3 Success Reports.png";
import BlastSlide1 from "images/blastSlide1.png";
import BlastSlide2 from "images/blastSlide2.png";
import DripsSlide1 from "images/dripsSlide1.png";
import DripsSlide2 from "images/dripsSlide2.png";
import { EditIcon, ScheduleIcon, ShareIcon, StatisticsIcon, SlidesPreviewIcon } from "icons";

export const eventsSlidesContent = [
  {
    appName: "Journey AI Events",
    header: "Easy to use event managing tool.",
    content:
      "Create and manage community events easily and quickly. Analyze the performance of your events with performance analytics. Scheduling superpowers at your fingertips.",
    bottomHeader: "Top Features",
    button: "Contact Sales Team",
    features: [
      { icon: <EditIcon />, feature: "Edit in Live Preview" },
      { icon: <ScheduleIcon />, feature: "Freedom to Schedule" },
      { icon: <ShareIcon />, feature: "Share on Social Media" },
      { icon: <StatisticsIcon />, feature: "Analyze Performance" },
    ],
  },
  {
    slideName: "Top Features",
    header: "Edit in Live Preview",
    description:
      "The WYSIWYG editor lets you to see prospect’s experience without refreshing or switching screens.",
    imgSrc: EventSlide1,
  },
  {
    slideName: "Top Features",
    header: "Freedom to Schedule",
    description:
      "You can now schedule the invites at the right date and time to your desired audience groups.",
    imgSrc: EventSlide2,
  },
  {
    slideName: "Top Features",
    header: "Share on Social Media",
    description:
      "Save time by scheduling your event post directly from our platform to your Facebook and Twitter.",
    imgSrc: EventSlide3,
  },
  {
    slideName: "Top Features",
    header: "Analyse Performance",
    description:
      "Gain valuable insigts with the event analytics. Put your data to use with our easy to access reporting.",
    imgSrc: EventSlide4,
  },
];

export const OffersSlidesContent = [
  {
    appName: "Journey AI Offers",
    header: "Easy to use offer managing tool.",
    content:
      "Allows you to create, manage offers easy and quick. It will let you schedule the activities and sit back. Analyse the performance of your offers with the help of reports.",
    bottomHeader: "Top Features",
    button: "Contact Sales Team",
    features: [
      { icon: <EditIcon />, feature: "Edit in Live Preview" },
      { icon: <ScheduleIcon />, feature: "Freedom to Schedule" },
      { icon: <ShareIcon />, feature: "Share on Social Media" },
    ],
  },
  {
    slideName: "Top Features",
    header: "Edit in Live Preview",
    description:
      "The WYSIWYG editor lets you to see prospect’s experience without refreshing or switching screens.",
    imgSrc: OfferSlide1,
  },
  {
    slideName: "Top Features",
    header: "Freedom to Schedule",
    description:
      "You can now schedule the offer post on property website and to your prospects at the right date and time.",
    imgSrc: OfferSlide2,
  },
  {
    slideName: "Top Features",
    header: "Share on Social Media",
    description:
      "Save time by scheduling your offer post directly from our platform to  your Facebook and Twitter.",
    imgSrc: OfferSlide3,
  },
];

export const rafSlidesContent = [
  {
    appName: "Journey AI Suite : Refer-a-Friend",
    header: "All-in-one Referal Program",
    content:
      "Friends make the best neighbors. Showcase program benefits and nudge friends with drip reminders. Increase participation with accurate tracking, and transparent payouts.",
    bottomHeader: "Easy to Use",
    button: "Schedule a Demo",
    features: [
      { icon: <EditIcon />, feature: "Edit" },
      { icon: <SlidesPreviewIcon />, feature: "Omichannel Preview" },
      { icon: <ScheduleIcon />, feature: "Schedule" },
    ],
  },
  {
    slideName: "Easy to Use",
    header: "Edit",
    description:
      "Make changes easily. Edit your campaign and concession amounts from one location.",
    imgSrc: RafSlide1,
  },
  {
    slideName: "Easy to Use",
    header: "Omichannel Preview",
    description:
      "You can preview all the assets in desktop, mobile and sms views based on the details from the Edit page.",
    imgSrc: RafSlide2,
  },
  {
    slideName: "Easy to Use",
    header: "Schedule",
    description:
      "You can now schedule the referral invite  email/SMS to your residents for the selected date and time.",
    imgSrc: RafSlide3,
  },
];

export const sCSlidesContent = [
  {
    slideName: "Step 1",
    header: "Increase Performance",
    description:
      "Set a goal to achieve maximum results. Easy to use and edit. Adjust each property’s goal as needed.",
    imgSrc: SetGoal,
  },
  {
    slideName: "Step 2",
    header: "Monitor Progress",
    description:
      "See and analyse the performance of the whole portfolio or drill down to each property for more information.",
    imgSrc: SuccessAnalysis,
  },
  {
    slideName: "Step 3",
    header: "Success Management",
    description:
      "See reports to analyse performance. Nudge underperforming properties or give kudos straight from the app.",
    imgSrc: SuccessReports,
  },
];

export const blastsSlidesContent = [
  {
    appName: "Journey AI - Blasts",
    header: "Impactful Results with 15 Mins per Week",
    content:
      "Increase your lead-to-lease velocity. Delegate email communications to onsite teams. Control your brand with protected templates and an approval process.",
    bottomHeader: "Top Features",
    button: "Contact Sales Team",
    features: [
      { icon: <EditIcon />, feature: "Edit in Live Preview" },
      { icon: <ScheduleIcon />, feature: "Freedom to Schedule" },
    ],
  },
  {
    slideName: "Top Features",
    header: "Edit in Live Preview",
    description:
      "The editor lets you to see prospect’s experience without refreshing or switching screens. ",
    imgSrc: BlastSlide1,
  },
  {
    slideName: "Top Features",
    header: "Freedom to Schedule",
    description:
      "You can now schedule the invites at the right date and time to your desired audience groups.",
    imgSrc: BlastSlide2,
  },
];

export const dripsSlidesContent = [
  {
    appName: "Journey AI - Drips",
    header: "Autonomous Lifecycle Marketing",
    content:
      "Drips uses digital ‘angels’ to engage prospects and residents throughout their entire customer lifetime. These angels send a sequence of targeted emails to encourage customers to take the next step.",
    bottomHeader: "Top Features",
    button: "Contact Sales Team",
    features: [
      { icon: <EditIcon />, feature: "Edit in Live Preview" },
      { icon: <ScheduleIcon />, feature: "Freedom to Schedule" },
    ],
  },
  {
    slideName: "Top Features",
    header: "Edit in Live Preview",
    description:
      "The editor lets you to see prospect’s experience without refreshing or switching screens. ",
    imgSrc: DripsSlide1,
  },
  {
    slideName: "Top Features",
    header: "Freedom to Schedule",
    description:
      "You can now schedule the invites at the right date and time to your desired audience groups.",
    imgSrc: DripsSlide2,
  },
];